<template>
<div>
  <v-dialog v-model="show_detail"
            scrollable
            persistent
            max-width="800"
  >
    <v-card >
      <div
          style="position: absolute;left: 5px;top: 5px;"
          @click="show_detail=false;$emit('close');"
      >
        <svg width="44" height="44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="44" height="44" rx="22" class="back-btn"/>
          <path d="M28.6665 22.2285C28.6665 22.5449 28.4314 22.8064 28.1263 22.8478L28.0415 22.8535L15.5415 22.8535C15.1963 22.8535 14.9165 22.5737 14.9165 22.2285C14.9165 21.9121 15.1516 21.6506 15.4567 21.6092L15.5415 21.6035L28.0415 21.6035C28.3867 21.6035 28.6665 21.8833 28.6665 22.2285Z" fill="black"/>
          <path d="M21.024 26.8059C21.2686 27.0495 21.2695 27.4452 21.0259 27.6898C20.8045 27.9122 20.4573 27.9331 20.2122 27.7521L20.142 27.6917L15.1004 22.6717C14.8773 22.4497 14.857 22.1012 15.0395 21.8562L15.1003 21.786L20.142 16.7652C20.3866 16.5216 20.7823 16.5224 21.0259 16.767C21.2473 16.9893 21.2667 17.3366 21.0847 17.5809L21.024 17.6509L16.4273 22.2291L21.024 26.8059Z" fill="black"/>
        </svg>
      </div>
      <v-card-title class="mb-5 w-100">
        <v-tooltip left color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-avatar v-bind="attrs" v-on="on" size="70">
              <v-img :src="task.created_user.profile_picture"></v-img>
            </v-avatar>
          </template>
          <div>
            ایجاد شده توسط
            {{task.created_user.get_full_name}}
          </div>
        </v-tooltip>
        <h4 class="mx-auto">{{ task.title }}</h4>
      </v-card-title>
      <v-card-text class="container" id="task_content">

          <!-- Title -->
          <h3>توضیحات : </h3>
          <p class="text-justify mx-4 mt-2">{{task.description}}</p>

          <v-divider class="my-5"></v-divider>

          <h3>کاربران : </h3>
            <div class="mr-lg-10 mr-xl-10 mr-sm-7 my-13">
              <div class="row rounded-pill " v-for="user in task.users">
                <div class="col col-5 row pt-5">
                  <v-img v-if="user.profile_picture" class=" rounded-circle user-online-img" max-width="50px" height="50px" :src="user.profile_picture"></v-img>
                  <h2 class="mt-5 mr-3">
                    <span>{{user.get_full_name}}</span>
                    <div v-if="task.worker_users_added_by || 1">
                    </div>
                  </h2>
                </div>
                <v-col cols="6" >
                  <v-autocomplete
                      :items="all_worker_users"
                      item-text="get_full_name"
                      v-model="task_worker_users"
                      @change="change_users"
                      item-value="id"
                      disabled="$GLOBAL_DATA.user['degree'] >= 2"
                      color="#D20003"
                      label="انتخاب کاربران"
                      closable-chips multiple deletable-chips
                      style="border-radius: 5px "
                  >
                    <template v-slot:selection="data">
                      <v-chip v-bind="data.attrs" @click="data.select" color="#cccccc">
                        <v-avatar>
                          <v-avatar v-if="data.item['profile_picture']">
                            <v-img :src="BACKEND_LINK + data.item['profile_picture']"></v-img>
                          </v-avatar>
                          <v-icon v-else >mdi-account-circle</v-icon>
                        </v-avatar>
                        <span class="mr-4">{{data.item.get_full_name}}</span>
                      </v-chip>
                    </template>

                    <template v-slot:item="{ props, item }">
                      <div class="my-2">
                        <v-avatar>
                          <v-avatar v-if="item['profile_picture']">
                            <v-img :src="BACKEND_LINK + item['profile_picture']"></v-img>
                          </v-avatar>
                          <v-icon v-else style="font-size: 4.5em">mdi-account-circle</v-icon>
                        </v-avatar>
                        <span class="mr-4">{{item.get_full_name}}</span>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>

              </div>
            </div>
        <v-divider class="my-5"></v-divider>
        <div class="row text-center">
          <v-col><h3>مکان : {{task.location}}</h3></v-col>
          <v-col><h3>تگ : {{task.tag}}</h3></v-col>
        </div>
        <v-divider class="my-5"></v-divider>
        <div class="row" v-if="task.need_confirm">
          <v-col>
            <h3 class="d-inline">شماره تماس تایید کننده :</h3>
            {{ task.confirm_mobile_number }}
          </v-col>
          <v-col v-if="task.device">
            <h3 class="d-inline">تایید شده :</h3>
            <span class="mr-4">
              <v-icon v-if="task.is_confirm" color="success">mdi-checkbox-marked</v-icon>
              <v-icon v-else color="red">mdi-checkbox-blank-outline</v-icon>
            </span>
          </v-col>
        </div>
        <v-divider v-if="task.need_confirm" class="my-5"></v-divider>
        <div class="row">
          <v-col>
            <h3 class="d-inline">دسته بندی :</h3>
            {{ task.category }}
          </v-col>
          <v-col v-if="task.device">
            <h3 class="d-inline">دستگاه :</h3>
            <span class="mr-4">{{ task.device.number }} - {{ task.device.capacity }} - {{ task.device.location_at }} - {{ task.device.location_use }}</span>
          </v-col>
        </div>
        <v-divider class="my-5"></v-divider>
        <div>
          <div>
            <h3 class="d-inline">وضعیت :</h3>
            <v-alert color="warning" class="text-center" outlined dense v-if="task.finished_task_by_user_2 && task.status === '2'">
              برای این کار درخواست اتمام ثبت شده ، پس از بررسی وضعیت را ثبت کنید.
            </v-alert>
            <v-stepper alt-labels :value="task.status" flat>
              <v-stepper-header>
                <v-stepper-step step="0" :complete="task.status > 0">
                  در صف انتظار
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="1" :complete="task.status > 1">
                  در حال انجام
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2" :complete="task.status > 2">
                  در صف خرید
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3" :complete="task.status > 3">
                  در انتظار تایید پایان کار
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4" :complete="task.status === '4'">
                  پایان کار
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>

          </div>
        </div>
        <div v-if="task.file" class="py-5">
         <div class="text-center">
           <v-btn color="success"
                  @click="download_file">
             دانلود فایل این کار با حجم {{formatBytes(file_length)}}
           </v-btn>
         </div>
        </div>
        <section v-if="task_messages" id="messages-box">
          <div v-for="msg in task_messages" :class="`message-box my-5 mx-lg-10 mx-xl-10  ${msg.user.id === $GLOBAL_DATA.user['id']?'my-messages':'message-left'}`">
            <v-row>
              <v-col cols="2">
                <v-img           :src="msg.user.profile_picture" alt="profile_pic" width="50px" height="50px"
                                 class="rounded-circle ml-0 mr-auto"></v-img>
              </v-col>
              <v-col>
                <h4 class="mr-0 ml-auto">{{msg.user.first_name + ' ' + msg.user.last_name}}</h4>
              </v-col>
              <v-col cols="12">
                <div class="mx-5 text-justify">
                  {{msg.msg}}
                </div>
              </v-col>
              <v-col cols="12" v-if="msg.img">
                <a :href="msg.img" download="msg" target="_blank" rel="noopener noreferrer">
                  <v-img class="mx-auto rounded-xl pa-10" :src="msg.img" height="10em" max-width="20em"></v-img>
                </a>
              </v-col>
              <v-col cols="12" class="pl-5 text-left">
                <v-tooltip top class="ml-5">
                  <template v-slot:activator="{ on, attrs }">
                    <small v-bind="attrs" v-on="on"
                           class="text-black"
                    >{{new Date(msg['created_at'].split('T')[0]).toLocaleDateString('fa-IR')}}</small>
                  </template>
                  <span>{{ convert_en_to_fa_number(msg['created_at'].split('T')[1].slice(0,5)) }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <div>

            </div>
          </div>
        </section>
      </v-card-text>
      <v-card-actions v-if="!task['finished_task']" style="display: grid">
        <div id="send_message_input" class="mt-5">
          <v-row>
            <v-col cols="1" class="text-center m-2">
              <v-file-input
                  accept="image/*"
                  v-model="message_input.img"
                  :show-size="1000"
                  color="deep-purple-accent-4"
                  prepend-icon="mdi-paperclip"
                  @change="previewmessageFile"
                  variant="outlined" hide-input
              ></v-file-input>
            </v-col>
            <v-col cols="1" v-if="preview">
              <v-img
                  :src="preview"
                  max-height="200"
                  max-width="200"
              ></v-img>
            </v-col>
            <v-col>
              <v-text-field
                  filled rounded
                  v-model="message_input.msg"
                  placeholder="ثبت گزارش"
                  append-outer-icon="mdi-send"
                  @keyup.enter="send_message"
              >
                <template v-slot:append-outer>
                  <v-icon :color="message_input.msg?'primary':''"
                          @click="send_message"
                          style="transform: rotate(180deg)">
                    mdi-send
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-row class="ma-5 mt-0" v-if="$GLOBAL_DATA.user['degree'] >= 2">
          <v-col>
            <v-btn block large outlined
                   v-if="task.status !== '4' && task.status !== '3' && $GLOBAL_DATA.user['degree'] >= 2"
                   class="elevation-0 rounded-0 text-bold"
                   @click="set_task_done()"
                   color="warning"
                   :loading="done_btn_loading"
                   :disabled="done_btn_loading">
              تغییر وضعیت به
              {{ statuses[parseInt(task.status)+1] }}
            </v-btn>
          </v-col>
          <v-col v-if="task.status == 1 && $GLOBAL_DATA.user['degree'] >= 2">
            <v-btn block large outlined
                   class="elevation-0 rounded-0 text-bold"
                   @click="set_task_done(true)"
                   color="success"
                   :loading="done_btn_loading"
                   :disabled="done_btn_loading">
              تغییر وضعیت به
              {{ statuses[parseInt(task.status)+2] }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn block large text
                   v-if="task.status >= 1"
                   class="elevation-0 rounded-0 text-bold"
                   @click="set_task_previous()"
                   color="red"
                   :loading="previous_btn_loading"
                   :disabled="previous_btn_loading">
              بازگشت وضعیت به
              {{ statuses[parseInt(task.status)-1] }}
            </v-btn>
          </v-col>
        </v-row>
        <div>
          <v-btn block large
                 v-if="task.status === '3' && $GLOBAL_DATA.user['degree'] >= 2"
                 class="elevation-0 rounded-0 text-bold"
                 @click="set_task_done()"
                 color="warning"
                 :loading="done_btn_loading"
                 :disabled="done_btn_loading">
            {{ statuses[parseInt(task.status)+1] }}
          </v-btn>
          <v-btn block large
                 v-else-if="$GLOBAL_DATA.user['degree'] >= 2"
                 class="elevation-0 rounded-0 text-bold"
                 @click="send_worker_users()"
                 color="success"
                 :disabled="!(worker_users.length>0 || task_worker_users.length>0)"
                 :loading="done_btn_loading">
            ثبت کاربران
          </v-btn>
        </div>
      </v-card-actions>
      <v-card-actions v-else-if="task['finished_task']" class="text-center">
        <div  class="py-5 text-center font-bold mx-auto" style="font-size:  1.4em">
          پایان یافته در تاریخ
          <strong>{{new Date(task['ended_at'].split('T')[0]).toLocaleDateString('fa-IR')}}</strong>
          ساعت
          <strong>{{convert_en_to_fa_number(task['ended_at'].split('T')[1].slice(0,5)) }}</strong>
        </div>
      </v-card-actions>
    </v-card>

  </v-dialog>
</div>
</template>

<script>
import axios, {toFormData} from "axios";
import FileDownload from "js-file-download"

export default {
  name: "task-detail",
  props:['task', 'show_detail'],
  data:()=>({
    key: localStorage.getItem('key'),
    preview:null,
    message_input:{
      msg:'',
      img: null
    },
    task_messages:[],
    done_btn_loading:false,
    previous_btn_loading: false,
    file_length: 0,
    worker_users:[],
    task_worker_users:[],
    all_worker_users:[],
    statuses : [
      'در صف انتظار',
      'در حال انجام',
      'در صف خرید',
      'در انتظار تایید پایان کار',
      'پایان کار',
    ],

  }),
  watch :{
    show_detail:function(val) {
      if(val){
        this.get_message();
        if (this.$props.task) {
          this.task_worker_users = [];
          for (let i = 0; i < this.$props.task.worker_users.length; i++) {
            this.$data.task_worker_users.push(this.$props.task.worker_users[i].id);
          }
        }
        this.get_file_size();
      }
    },
  },
  destroyed() {
    this.task_messages = [];
  },
  created() {
    this.get_users();
  },
  methods:{
    previewmessageFile(file) {
      const selectedFile = file;
      if (selectedFile) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        reader.readAsDataURL(selectedFile);
      }
    },
    change_users(){
      this.en_update_btn = this.task_worker_users.length !== this.task.worker_users.length;
    },
    send_worker_users(){
      this.done_btn_loading = true;
      let data = {
        worker_users : this.task_worker_users
      }
      axios
          .put(`${this.BACKEND_LINK}/api/tasks/update-w-users/${this.task.id}`, data,
              {
                headers: {'Authorization': `Token ${this.key}`}
              })
          .then((response)=>{
            this.$snotify.success(response.data.msg)
            this.en_update_btn = false;
            this.$emit('close');
          })
          .finally(()=>{
            this.done_btn_loading = false;
          })
    },
    get_users(){
      axios.get(this.BACKEND_LINK + '/api/account/users-filter-degree/?degree=1', {
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.all_worker_users = response.data;
      })
    },
    get_message(){
        axios
            .get(`${this.BACKEND_LINK}/api/tasks/message/?task-id=${this.task.id}`, {
              headers: {'Authorization': `Token ${this.key}`}
            })
            .then((response)=>{
              this.task_messages = response.data;
            })
    },
    send_message(){
      if(this.message_input.msg){
        let data = new FormData()
        data.append('msg', this.message_input.msg)
        if(this.message_input.img) {
          this.$snotify.warning('در حال ارسال تصویر لطفا منتظر بمانید...');
          data.append('img', this.message_input.img)
        }
        data.append('task-id', this.task.id)
        axios
            .post(`${this.BACKEND_LINK}/api/tasks/message/`, data,
                {headers: {'Authorization': `Token ${this.key}`}
            })
            .then((response)=>{
              this.message_input.msg = null;
              this.get_message();
              this.$snotify.success(response.data.msg);
            })
      }
    },
    download_file(){
      axios({
        url: this.task.file,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        FileDownload(response.data, this.task.file); // TODO: Fix download file name
      });
    },
    get_file_size() {
      axios
          .head(this.task.file)
          .then((response) => {
            this.file_length = response.headers["content-length"];
          })
    },

    set_task_previous(){
      axios
          .put(`${this.BACKEND_LINK}/api/tasks/previous-status/${this.task.id}`, this.task,{
            headers: {'Authorization': `Token ${this.key}`}
          })
          .then((response)=>{
            if(response.data.status){
              this.task.status = response.data['task_status'];
              this.$snotify.success(response.data.msg);
              this.show_detail=false;
              this.$emit('close');
            }
            else {
              this.$snotify.warning(response.data.msg);
            }
          })
          .catch((errors)=>{
            this.$snotify.error(errors.response.data.msg);
          })
    },
    set_task_done(skip_shop=false){
        axios
            .put(`${this.BACKEND_LINK}/api/tasks/update-status/${this.task.id}${skip_shop?'?skip_shop=true':''}`, this.task,{
              headers: {'Authorization': `Token ${this.key}`}
            }).then((response)=>{
              if(response.data.status){
                this.task.status = response.data['task_status'];
                this.$snotify.success(response.data.msg);
                this.show_detail=false;
                this.$emit('close');
            }
            else {
              this.$snotify.warning(response.data.msg);
            }
          })
            .catch((errors)=>{
              this.$snotify.error(errors.response.data.msg);
            })
    },
  },
}
</script>

<style>
.message-left{
  direction: ltr;
}
.my-messages{
  color: rgb(0, 0, 0) !important;
}
.message-box:last-child{
  animation: newMessage forwards 2s;
}
@keyframes newMessage {
  from  { background-color: rgba(0, 215, 0, 0.5) !important }
  to { background-color: rgba(0, 0, 215, 0.4) !important}
  100% { background-color: rgba(203, 204, 206, 0.3) !important}
}

</style>
